import {
  GET_CELL_MODEM_LIST_REQUEST,
  GET_CELL_MODEM_LIST_SUCCESS,
  GET_CELL_MODEM_LIST_FAILURE,
  EXTEND_DATA_PLAN_REQUEST,
  EXTEND_DATA_PLAN_SUCCESS,
  EXTEND_DATA_PLAN_FAILURE,
  GET_PRICES_REQUEST,
  GET_PRICES_SUCCESS,
  GET_PRICES_FAILURE,
  RESET_SNACKBAR,
  GET_FEEDBACK_REQUEST,
  GET_FEEDBACK_SUCCESS,
  GET_FEEDBACK_FAILURE,
  POST_FEEDBACK_REQUEST,
  POST_FEEDBACK_SUCCESS,
  POST_FEEDBACK_FAILURE
} from "./constants";

const initialState = {
  cellModemList: { cellModem: []},
  loading: false,
  message: "",
  messageType: "",
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_CELL_MODEM_LIST_REQUEST:
      return { ...state, loading: true };
    case GET_CELL_MODEM_LIST_SUCCESS:
      return {
        ...state,
        cellModemList: action.cellModemList,
        loading: false,
      };
    case GET_CELL_MODEM_LIST_FAILURE:
      return {
        ...state,
        cellModemList: {},
        message: action.error && action.error.message ? action.error.message : "Unable to process your request. Please try after some time!!!",
        messageType: "error",
        loading: false,
      };
    case EXTEND_DATA_PLAN_REQUEST:
      return { ...state, loading: true };
    case EXTEND_DATA_PLAN_SUCCESS:
      return {
        ...state,
        extend_data_plan: action.extend_data_plan,
        loading: false,
      };
    case EXTEND_DATA_PLAN_FAILURE:
      return {
        ...state,
        extend_data_plan: {},
        message: action.error && action.error.message ? action.error.message : "Unable to process your request. Please try after some time!!!",
        messageType: "error",
        loading: false,
      };
    case GET_PRICES_REQUEST:
      return { ...state, loading: true };
    case GET_PRICES_SUCCESS:
      return {
        ...state,
        prices: action.prices,
        loading: false,
      };
    case GET_PRICES_FAILURE:
      return {
        ...state,
        extendDataplan: {},
        message: action.error && action.error.message ? action.error.message : "Unable to process your request. Please try after some time!!!",
        messageType: "error",
        loading: false,
      };
    case GET_FEEDBACK_REQUEST:
      return { ...state };
    case GET_FEEDBACK_SUCCESS:
console.log("GET_FEEDBACK_SUCCESS",action)
      return {
        ...state,
        getFeedbackresult: action.getFeedbackresult,
      };
    case GET_FEEDBACK_FAILURE:
      return {
        ...state,
        extendDataplan: {},
        message: action.error && action.error.message ? action.error.message : "Unable to process your request. Please try after some time!!!",
        messageType: "error"
      };
    case POST_FEEDBACK_REQUEST:
      return { ...state, loading: true };
    case POST_FEEDBACK_SUCCESS:
      return {
        ...state,
        getFeedbackresult: action.getFeedbackresult,
        loading: false,
      };
    case POST_FEEDBACK_FAILURE:
      return {
        ...state,
        extendDataplan: {},
        message: action.error && action.error.message ? action.error.message : "Unable to process your request. Please try after some time!!!",
        messageType: "error",
        loading: false,
      };
    case RESET_SNACKBAR:
      return { ...state, messageType: "" };
    default:
      return state;
  }
}

export default reducer;
